import { Injectable, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { BreadcrumbResult, IBreadcrumbsResolve } from '../breadcrumbs/breadcrumbs.resolver';

@Injectable({ providedIn: 'root' })
export class HomeBreadcrumbsResolver implements IBreadcrumbsResolve {
    private sitecore = inject(Sitecore);
    private urlHelper = inject(UrlHelperService);

    resolve(): BreadcrumbResult {
        const title = this.sitecore.seo;

        return [{ icon: 'theme-home', title: title.HomeBreadcrumbTitle, url: this.urlHelper.getHomeUrl(), ignoreBreadcrumb: true }];
    }
}
